import app from 'flarum/forum/app';
import icon from 'flarum/common/helpers/icon';
import Field from './Field';

export default class Radio extends Field {
    whiteListConfigProperties() {
        return super.whiteListConfigProperties().concat([
            'options',
            'other',
        ]);
    }

    configure() {
        return [
            this.optionsRule(),
            this.otherRule(),
        ];
    }

    fill(display: boolean = false) {
        return this.choiceView((checked, onchange, disabled, key, children) => {
            const style = app.forum.attribute<string>('formulaireRadioStyle');

            const isFA = style && style.substr(0, 2) === 'fa';

            return m('label', {
                className: isFA ? 'FormulaireFAControl' : undefined,
            }, [
                m('input', {
                    type: 'radio',
                    name: display ? undefined : this.uniqueFieldId(),
                    value: display ? undefined : key,
                    checked,
                    onchange,
                    disabled,
                }),
                isFA ? icon('fa' + style.substr(2, 1) + ' fa-' + (checked ? 'dot-' : '') + style.substr(4)) : null,
                children,
            ]);
        }, display, true);
    }

    display() {
        return this.fill(true);
    }
}
